import "./chunk-EUXUH3YW.js";

// libs/ui-components/src/lib/modules/icon/icons/cross_8.svg.ts
import { svg } from "lit";
var cross8Svg = svg`
<svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M6 2L2 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M2 2L6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;
export {
  cross8Svg
};
//# sourceMappingURL=cross_8.svg-UQSEH4S4.js.map
